import API from '../../../lib/commons/api'
import {
  Program,
  ProgramManagementResponse,
} from '../../../view/pages/ProgramManagement/programManagement'

type ReferencedValue = {
  uuid: string
  code: string
  name: string
}

export const fetchProgramList = async (): Promise<Program[]> => {
  const response = await API.functional.request(
    'GET',
    '/api/v1/programs/referenced_values'
  )
  const values = response.json as ReferencedValue[]
  return values.map(v => ({
    uuid: v.uuid,
    code: v.code,
    displayName: v.name,
  }))
}

export const fetchProgramManagementData = async (
  programUuid: string
): Promise<ProgramManagementResponse> => {
  const response = await API.functional.request(
    'GET',
    `/api/v1/programs/${programUuid}/reports`
  )
  return response.json as ProgramManagementResponse
}
